/**
 * CarDetail class - třída s funkcemi pro kartu vozu
 */
var CarDetail = window.CarDetail = function () {}

CarDetail.prototype.init = function () {
    this.initDetailSlider();
    this.initDetailOneImageSlider();
    this.initCarDetailThumbsSlider();
    this.initFixedNotification();
    this.initFormButtons();
    this.initFixedMainInfo();
    this.initFixedMobileBtns();
    this.initReadMoreText();
    this.initAosPluginButtons();
    this.initShowMoreBtn();
    this.initShowFakeMilageInfo();
    this.initPillSlider();
    this.initLightboxGallery();
    this.initPacketShowMore();
    this.initDetailAccordion();
    this.initCertificateShowMore();

    window.installmentCalculatorCar = new InstallmentCalculatorCar();
    window.installmentCalculatorCar.init();
}

CarDetail.prototype.initCarDetailThumbsSlider = function () {
    var $slider = $('.initCarDetailThumbs');

    if (!$slider.length) return;

    $slider.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        speed: 300,
        responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });
};

CarDetail.prototype.initPillSlider = function () {
    $('.pill_slider').each(function () {
        var $slider = $(this);
        var $track = $slider.find('.pill_slider__track');
        var $dotsWrap = $slider.find('.pill_slider__dots');
        var count = $track.find('.pill_slider__slide').length;

        if (count <= 1) {
            $dotsWrap.hide();
            return;
        }

        $track.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            fade: true,
            cssEase: 'ease-in-out',
            speed: 400,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnHover: true,
            appendDots: $dotsWrap,
            customPaging: function () {
                return $('<span>');
            }
        });
    });
}


CarDetail.prototype.initShowFakeMilageInfo = function () {
    $(".showFakeMilageInfo").click(function () {
        $('html, body').animate({
            scrollTop: $('.showFakeMilageInfoText').offset().top - 150
        }, 1000);
    });
}

CarDetail.prototype.initShowMoreBtn = function () {
    $(".initShowMoreBtn").click(function () {
        $(this).closest('.show-more-btn').find('.initShowMoreBtn').removeClass('d-none');
        $(this).addClass('d-none');

        if ($(this).hasClass('show-more-btn-text-more')) {
            $(this).closest('.show-more-wrapper').find('.show-more-hidden-mobile').slideDown();
        } else {
            $(this).closest('.show-more-wrapper').find('.show-more-hidden-mobile').slideUp();
        }
    });
}

CarDetail.prototype.initPacketShowMore = function () {
    $(".packet-show-more").click(function () {
        var $inner = $(this).closest('.detail_attr_inner');
        $inner.find('.packet-hidden-item').hide().removeClass('d-none d-md-block').fadeIn(400);
        $(this).hide();
    });
}

CarDetail.prototype.initDetailAccordion = function () {
    $(".detail_attr_holder h3").click(function () {
        if ($(window).width() < 768) {
            $(this).toggleClass('collapsed');
            $(this).siblings('.detail_attr_inner').slideToggle(300);
        }
    });
}

CarDetail.prototype.initCertificateShowMore = function () {
    $(".cert-show-more").click(function () {
        var $content = $(this).siblings('.certification_line__content');
        $content.find('> p').fadeIn(400);
        $(this).hide();
    });
}

CarDetail.prototype.initAosPluginButtons = function () {
    var clicked = false;
    $(".aos-button-trigger").click(function () {
        var self = this;
        $('#aosPluginModal').modal('show');

        if (!clicked) {
            $($('.AOSTopGallery .slick-next'))[0].click();

            setTimeout(function () {
                $('.LOSControlsWrapper ' + $(self).data('target'))[0].click();
                setTimeout(function () {
                    $('.AOSTopGallery').css('opacity', '1');
                }, 500);
            }, 500);

            clicked = true;
        }
    });

    $(".aos-button").click(function () {
        dataLayer.push({
            'event': 'gaEvent',
            'gaEventData': {
                'eCat': 'Button',
                'eAct': 'Button-aos',
                'eLab': $(this).text()
            }
        });
    });


    // var loaded = false;
    // $(".aos-button").click(function () {
    //     if (loaded) {
    //         $('#aosPluginModal').modal('show');
    //     } else {
    //         $.nette.ajax({
    //             type: 'GET',
    //             url: $(this).data('href')
    //         }).done(function () {
    //             $('#aosPluginModal').modal('show');
    //             $('.close').removeClass('d-none');
    //             loaded = true;
    //
    //             $('AOSPlayVideoButton_').trigger('click');
    //
    //             // console.log(interval);
    //             // var interval = setInterval(function () {
    //             //     console.log($('.LOSButton.degree_en').length);
    //             //
    //             //     if ($('.LOSButton.degree_en').length) {
    //             //         $('.LOSButton.degree_en').trigger('click');
    //             //         $('.LOSButton.degree_en').addClass('tabShow');
    //             //     }
    //             //
    //             //     if ($('.LOSButton.degree_en.tabShow').length) {
    //             //         // clearInterval(interval);
    //             //     }
    //             // }, 1000);
    //         });
    //     }
    //
    //
    // });
}

CarDetail.prototype.initReadMoreText = function () {
    var $el, $ps, $up, totalHeight;

    $(".read-more-gradient .btn").click(function () {

        totalHeight = 0

        $el = $(this);
        $p = $el.parent();
        $up = $p.parent();
        $ps = $up.find("p:not('.read-more')");

        // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
        $ps.each(function () {
            console.log($(this).outerHeight());
            totalHeight += $(this).outerHeight() + 15;
        });
        totalHeight += 45;

        $up
            .css({
                // Set height to prevent instant jumpdown when max height is removed
                "height": $up.height(),
                "max-height": 9999
            })
            .animate({
                "height": totalHeight
            });

        // fade out read-more
        $p.fadeOut();

        // prevent jump-down
        return false;

    });
}

CarDetail.prototype.initFixedMobileBtns = function () {
    $('.fake-click-installment').off('click').on('click', function (e) {
        $('#spocitat_splatky').trigger('click');
    });

    $('.fake-click-reserve').off('click').on('click', function (e) {
        $('#detail_rezervovat').trigger('click');
    });
}

CarDetail.prototype.initFixedMainInfo = function () {
    if ($(".detail_fixed_content").length) {
        $(window).on('scroll', function () {
            var y_scroll_pos = window.pageYOffset;
            var scroll_pos_test = $("#show_fixed_main_info_fix").offset();
            // var scroll_pos_test = 150;
            if (y_scroll_pos > scroll_pos_test.top) {
                $(".detail_fixed_content").addClass("fixed");
            } else {
                $(".detail_fixed_content").removeClass("fixed");
            }
        });
    }
}

CarDetail.prototype.callDataLayerEvent = function (eCat, eAct, eLab) {
    dataLayer.push({
        'event': 'gaEvent',
        'gaEventData': {
            'eCat': eCat,
            'eAct': eAct,
            'eLab': eLab
        },
        'eventCallback': function () {
            dataLayer.push({
                'gaEventData': undefined
            });
        }
    });
}

CarDetail.prototype.callDataLayerEventFormOpen = function (eventFormId, eventFormName, eventFormType) {
    window.dataLayer.push({
        'event': 'form',
        'form': {
            'id': eventFormId,
            'name': eventFormName,
            'state': 'Open',
            'type': eventFormType,
            'text': 'Odeslat'
        },
        _clear: true
    });
}

CarDetail.prototype.carsFormButtonClick = function (showID, btnEventName, formShowEventName, hash, eventFormId, eventFormName, eventFormType) {
    var self = this;

    var fixed_element_fix = parseInt($(".detail_fixed_content").height());

    if ($('.eye.detail_scroll_hide').is(':visible')) {
        fixed_element_fix = fixed_element_fix - parseInt($(".eye.detail_scroll_hide").height());
    }

    if ($('.desc-text.detail_scroll_hide').is(':visible')) {
        fixed_element_fix = fixed_element_fix - parseInt($(".desc-text.detail_scroll_hide").height());
    }

    if ($('.desc-text-bottom.detail_scroll_hide').is(':visible')) {
        fixed_element_fix = fixed_element_fix - parseInt($(".desc-text-bottom.detail_scroll_hide").height());
    }

    if ($(window).width() < 992) {
        fixed_element_fix = 0;
    }

    if (showID !== '#koupit-online_box') {
        $("#mamZajem_box,#ziskatVin_box,#spocitat_splatky_box,#odeslat_emailem_box,#rezervace_box,#online-prodej_box,#chci-slevu_box,#protiucet_box").hide();
    }

    var top = $("#slide_to_form_fix").offset().top;
    if (showID === '#rezervace_box' && $("#slide_to_right_form_fix").length) {
        top = $("#slide_to_right_form_fix").offset().top;
    }

    $(showID).show();

    // #koupit-online_box je jediny box, kvuli kteremu se ostatni boxy neskryvaji,
    // takze se dokument po jeho zobrazeni posune a offset #slide_to_form_fix
    // zmereny vyse uz ukazuje do kalkulacky. Mirime proto na sekci Koupit online
    // (nadpis + tlacitko), ne az na samotny formular pod ni.
    // #koupit-online-wrapper je jen pro cs, jinde spadneme zpatky na box.
    if (showID === '#koupit-online_box') {
        var $koupitOnlineTarget = $("#koupit-online-wrapper").length ? $("#koupit-online-wrapper") : $(showID);
        if ($koupitOnlineTarget.length) {
            top = $koupitOnlineTarget.offset().top;
        }
    }

    $('html, body').animate({
        scrollTop: top - fixed_element_fix
    }, 1000);
    if (btnEventName !== '') {
        self.callDataLayerEvent('Button', 'Button-form', btnEventName);
    }

    self.callDataLayerEvent('Form', 'Form-show', formShowEventName);
    self.callDataLayerEventFormOpen(eventFormId, eventFormName, eventFormType);
    window.location = hash;

    if (hash === '#rezervace' || hash === '#online-prodej' || hash === '#koupit-online' || hash === '#chci-slevu') {
        fbq('track', 'AddToWishlist', {
            content_type: "vehicle",
            "content_ids": $('#car-detail').data('webid'),
            value: $('#car-detail').data('price'),
            currency: "CZK"
        });
    } else if (hash === '#splatky' || hash === '#splatky2' || hash === '#splatky3') {
        fbq('track', 'CustomizeProduct', {
            content_type: "vehicle",
            "content_ids": $('#car-detail').data('webid'),
            value: $('#car-detail').data('price'),
            currency: "CZK"
        });
    }

};

CarDetail.prototype.initFormButtons = function () {
    var self = this;

    $(".detail_rezervovat").click(function () {
        if ($(this).hasClass('smaller') && isElementInView($('#frm-calcForm-name'), true)) {
            $('input[name="afterCalc"]').val('1');
        }
        self.carsFormButtonClick("#rezervace_box", 'Nezávazně rezervovat', 'Nezávazná rezervace vozu', '#rezervace', 1, 'Nezávazná rezervace', 'Rezervace');
    });
    if ($(".detail_rezervovat").length) {
        if (window.location.hash === '#rezervace') {
            self.carsFormButtonClick("#rezervace_box", '', 'Nezávazná rezervace vozu', '#rezervace', 1, 'Nezávazná rezervace', 'Rezervace');
        }
    }

    $("#mam_zajem").click(function () {
        $('input[name="afterCalc"]').val('0');
        self.carsFormButtonClick("#mamZajem_box", 'Mám zájem', 'Mám zájem', '#mamzajem', 7, 'Mám zájem', 'Mám zájem');
    });
    if ($("#mam_zajem").length) {
        if (window.location.hash === '#mamzajem') {
            self.carsFormButtonClick("#mamZajem_box", '', 'Mám zájem', '#mamzajem', 7, 'Mám zájem', 'Mám zájem');
        }
    }

    $("#ziskat_vin").click(function () {
        $('input[name="afterCalc"]').val('0');
        self.carsFormButtonClick("#ziskatVin_box", 'Získat VIN', 'Získat VIN', '#ziskatvin', 6, 'Získat VIN', 'Získat VIN');
    });
    if ($("#ziskat_vin").length) {
        if (window.location.hash === '#ziskatvin') {
            self.carsFormButtonClick("#ziskatVin_box", '', 'Získat VIN', '#ziskatvin', 6, 'Získat VIN', 'Získat VIN');
        }
    }

    $(".online-prodej").click(function () {
        $('input[name="afterCalc"]').val('0');
        self.carsFormButtonClick("#online-prodej_box", 'On-line prodej', 'On-line prodej', '#online-prodej', 5, 'On-line prodej', 'On-line prodej');
    });
    if ($("#online-prodej").length) {
        if (window.location.hash === '#online-prodej') {
            self.carsFormButtonClick("#online-prodej_box", '', 'On-line prodej', '#online-prodej', 5, 'On-line prodej', 'On-line prodej');
        }
    }

    $(".koupit-online").click(function () {
        $('input[name="afterCalc"]').val('0');
        self.carsFormButtonClick("#koupit-online_box", 'Koupit on-line', 'Koupit on-line', '#koupit-online', 3, 'Koupit on-line', 'Koupit on-line');
    });
    if ($("#koupit-online").length) {
        if (window.location.hash === '#koupit-online') {
            self.carsFormButtonClick("#koupit-online_box", '', 'Koupit on-line', '#koupit-online', 3, 'Koupit on-line', 'Koupit on-line');
        }
    }

    $(".chci-slevu").click(function () {
        $('input[name="afterCalc"]').val('0');
        self.carsFormButtonClick("#chci-slevu_box", 'Chci slevu', 'Chci slevu', '#chci-slevu', 4, 'Chci slevu', 'Chci slevu');
    });
    if ($(".chci-slevu").length) {
        if (window.location.hash === '#chci-slevu') {
            self.carsFormButtonClick("#chci-slevu_box", '', 'Chci slevu', '#chci-slevu', 4, 'Chci slevu', 'Chci slevu');
        }
    }

    console.log('dDSDADASDASD');
    $(".protiucet").click(function () {
        console.log('ASAD');
        $('input[name="afterCalc"]').val('0');
        self.carsFormButtonClick("#protiucet_box", 'Protiúčet', 'Protiúčet', '#protiucet', 4, 'Protiúčet', 'Protiúčet');
    });
    if ($(".protiucet").length) {
        if (window.location.hash === '#protiucet') {
            self.carsFormButtonClick("#protiucet_box", '', 'Protiúčet', '#protiucet', 4, 'Protiúčet', 'Protiúčet');
        }
    }

    $(".spocitat_splatky").click(function () {
        splatkyClicked = false;
        $('input[name="afterCalc"]').val('0');
        self.carsFormButtonClick("#spocitat_splatky_box", 'Spočítat splátky', 'Zvýhodněné splátky', $(this).data('hash'), 2, 'Spočítat splátky', 'Kalkulačka');
    });
    if ($("#spocitat_splatky").length) {
        if (window.location.hash === '#splatky') {
            self.carsFormButtonClick("#spocitat_splatky_box", '', 'Zvýhodněné splátky', '#splatky', 2, 'Spočítat splátky', 'Kalkulačka');
        }
        if (window.location.hash === '#splatky2') {
            self.carsFormButtonClick("#spocitat_splatky_box", '', 'Zvýhodněné splátky', '#splatky2', 2, 'Spočítat splátky', 'Kalkulačka');
        }
        if (window.location.hash === '#splatky3') {
            self.carsFormButtonClick("#spocitat_splatky_box", '', 'Zvýhodněné splátky', '#splatky3', 2, 'Spočítat splátky', 'Kalkulačka');
        }
    }

    $(".odeslat_emailem").click(function () {
        $('input[name="afterCalc"]').val('0');
        var fixed_element_fix = 0; // parseInt($(".detail_fixed_content_holder").height());
        if ($(window).width() < 992) {
            fixed_element_fix = 0;
        }
        $("#rezervace_box,#mamZajem_box,#ziskatVin_box,#spocitat_splatky_box,#online-prodej_box,#koupit-online_box,#chci-slevu_box,#protiucet_box").hide();
        $("#odeslat_emailem_box").show();
        $('html, body').animate({
            scrollTop: $("#slide_to_form_fix").offset().top - fixed_element_fix
        }, 1000);
        window.location = '#odeslatemailem';
        // fbq('track', 'AddToCart');
    });
    if ($(".odeslat_emailem").length) {
        if (window.location.hash === '#odeslatemailem') {
            $(".odeslat_emailem").trigger('click');
        }
    }

    $(".detail_phone_show").click(function () {
        self.callDataLayerEvent('Phone', 'Phone-show', 'Zobrazení telefonního čísla');
        $("#detail_phone span").text('727 888 777');
    });

    $("#detail_phone_mobile").click(function () {
        self.callDataLayerEvent('Phone', 'Phone-call', 'Zavolání telefonního čísla');
        var link = document.getElementById('detail_phone_mobile_fake');
        for (var i = 0; i < 50; i++)
            link.click();
    });
}

CarDetail.prototype.initFixedNotification = function () {
    if ($('.car-notification').length > 0) {
        if ($(window).width() > 750) {
            setTimeout(function () {
                $(".car-notification").animate({
                    "right": "+=500px"
                }, 1000);
            }, 3000);
        }

        $('.car-notification button').off('click').on('click', function () {
            var date = new Date();
            date.setDate(date.getDate() + 1);
            var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            var expire = 'expires=' + (isChrome ? date.toGMTString() : 0);

            if (window.location.host === 'www.skodovky.cz') {
                document.cookie = 'car-notification=1; path=/; domain=.skodovky.cz; ' + expire;
            } else if (window.location.host === 'www.skodovky.loc') {
                document.cookie = 'car-notification=1; path=/; domain=.skodovky.loc; ' + expire;
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'car-notification=1; path=/; domain=.dodavky-esa.cz; ' + expire;
            } else if (window.location.host === 'www.dodavky-esa.cz') {
                document.cookie = 'car-notification=1; path=/; domain=.dodavky-esa.loc; ' + expire;
            } else if (window.location.host === 'www.autoesaeu.loc') {
                document.cookie = 'car-notification=1; path=/; domain=.autoesaeu.loc; ' + expire;
            } else if (window.location.host === 'www.autoesa.eu') {
                document.cookie = 'car-notification=1; path=/; domain=.autoesa.eu; ' + expire;
            } else if (window.location.host === 'www.autoesa.loc') {
                document.cookie = 'car-notification=1; path=/; domain=.autoesa.loc; ' + expire;
            } else if (window.location.host === 'www.autoesa2.loc') {
                document.cookie = 'car-notification=1; path=/; domain=.autoesa2.loc; ' + expire;
            } else {
                document.cookie = 'car-notification=1; path=/; domain=.autoesa.cz; ' + expire;
            }
            $('.car-notification').remove();
        });
    }

}

CarDetail.prototype.initSliderCounter = function ($slider, $counter) {
    if (!$slider.length || !$counter.length) return;

    var getRealTotal = function () {
        return $slider.find('.slick-slide:not(.slick-cloned)').length;
    };

    $slider.on('afterChange', function (event, slick, currentSlide) {
        $counter.text((currentSlide + 1) + ' / ' + getRealTotal());
    });

    // Small delay so Slick finishes building clones before we read DOM
    setTimeout(function () {
        var total = getRealTotal();
        if (total <= 1) {
            $counter.hide();
        } else {
            $counter.show();
            $counter.text('1 / ' + total);
        }
    }, 100);
};

CarDetail.prototype.initDetailOneImageSlider = function () {
    var $slider = $('.initCarDetailOneImage');
    var $counter = $('.slider-counter');

    if (!$slider.length) return;

    $slider.slick({
        slidesToShow: 1,
        variableWidth: false,
        centerMode: false,
        responsive: [{
            breakpoint: 767,
            settings: {
                variableWidth: false,
                centerMode: false,
            }
        }]
    });

    this.initSliderCounter($slider, $counter);
}

CarDetail.prototype.initDetailSlider = function () {
    if ($(window).width() < 7066) {
        $('.detail2_special_offer__items').slick({
            slidesToShow: 3,
            // centerMode: true
            responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            }]
        });
    }

    if ($('.initCarDetailSliderNew').length) {
        $('.initCarDetailSlider').slick({
            slidesToShow: 1,
            variableWidth: true,
            centerMode: true,
            responsive: [{
                breakpoint: 767,
                settings: {
                    variableWidth: false,
                    centerMode: false,
                }
            }]
        });
    } else {
        $('.initCarDetailSlider').slick({
            centerMode: true,
            slidesToShow: 1,
            variableWidth: true,
            "autoRotate": -2,
        });
    }

    if ($(window).width() > 500) {
        var xzoom = null;
        $('.initCarDetailSlider').on('beforeChange', function (event, slick, currentSlide) {
            xzoom.destroy();
        });


        $('.initCarDetailSlider').on('afterChange', function (event, slick, currentSlide) {
            xzoom = $('.initCarDetailSlider .slick-current .xzoom').magnify();
        });

        xzoom = $('.initCarDetailSlider .slick-current .xzoom').magnify({
            magnifiedWidth: 1300,
            magnifiedHeight: 975,
        });
    }

    this.initSliderCounter($('.initCarDetailSlider'), $('.slider-counter--center'));

    $('.initCarDetailSlider').magnificPopup({
        delegate: '.slick-slide:not(.slick-cloned) a',
        type: 'image',
        gallery: {
            navigateByImgClick: false,
            enabled: true
        },
        callbacks: {
            imageLoadComplete: function () {
                $('img.mfp-img').trigger('zoom.destroy');
                if ($(window).width() > 500) {
                    $('img.mfp-img')
                        .wrap('<span style="display:inline-block"></span>')
                        .css('display', 'block')
                        .parent()
                        .zoom({
                            on: 'click',
                            magnify: 1.2,
                            onZoomIn: function () {
                                $('img.zoomImg').addClass('zoomOut');
                            },
                            onZoomOut: function () {
                                $('img.zoomImg').removeClass('zoomOut');
                            },
                        });
                }
            },
        }
    });

    $(".initCarDetailSlider .slick-slide").click(function (event) {
        event.preventDefault();
        event.stopPropagation();
        if ($(this).hasClass('slick-current')) {
            $('.initCarDetailSlider').magnificPopup('open');
            $('.initCarDetailSlider').magnificPopup('goTo', $(this).index() - 1);
        } else if ($(this).next().hasClass('slick-current')) {
            $('.initCarDetailSlider .slick-prev').trigger('click');
        } else {
            $('.initCarDetailSlider .slick-next').trigger('click');
        }
    });
}

CarDetail.prototype.initLightboxGallery = function () {
    var $lightbox = $('.detail_lightbox');
    var $lightboxSlider = $('.initCarDetailSlider');
    var $lightboxCounter = $lightbox.find('.slider-counter--center');

    if (!$lightbox.length) return;

    // Sdílená funkce – otevře lightbox a přejde na daný index
    var openLightbox = function (clickedIndex) {
        var mainHeaderHeight = $('.main_header').outerHeight() || 0;
        var detailMainHeight = $('.detail_main').outerHeight() || 0;
        $lightbox.css('height', (mainHeaderHeight + detailMainHeight + 10) + 'px');

        $lightbox.fadeIn(200);

        if ($lightboxSlider.hasClass('slick-initialized')) {
            $lightboxSlider.slick('setPosition');
            $lightboxSlider.slick('slickGoTo', clickedIndex, true);

            var total = $lightboxSlider.find('.slick-slide:not(.slick-cloned)').length;
            if ($lightboxCounter.length) {
                $lightboxCounter.text((clickedIndex + 1) + ' / ' + total);
            }
        } else {
            // Fallback – počkáme až se slider inicializuje
            setTimeout(function () {
                if ($lightboxSlider.hasClass('slick-initialized')) {
                    $lightboxSlider.slick('setPosition');
                    $lightboxSlider.slick('slickGoTo', clickedIndex, true);
                    var total = $lightboxSlider.find('.slick-slide:not(.slick-cloned)').length;
                    if ($lightboxCounter.length) {
                        $lightboxCounter.text((clickedIndex + 1) + ' / ' + total);
                    }
                }
            }, 300);
        }
    };

    // -- OneImage slider --
    var $oneImageSlider = $('.initCarDetailOneImage');
    if ($oneImageSlider.length) {
        $oneImageSlider.on('click', '.slick-slide:not(.slick-cloned)', function (e) {
            if ($(window).width() < 960) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            var clickedIndex = $oneImageSlider.find('.slick-slide:not(.slick-cloned)').index($(this));
            if (clickedIndex === 0) {
                clickedIndex = 1;
            }
            console.log('clickedIndex');
            console.log(clickedIndex);
            if (clickedIndex < 0) return;
            openLightbox(clickedIndex);
        });
    }

    // -- Thumbs slider --
    var $thumbsSlider = $('.initCarDetailThumbs');
    if ($thumbsSlider.length) {
        $thumbsSlider.on('click', '.slick-slide:not(.slick-cloned)', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var clickedIndex = $thumbsSlider.find('.slick-slide:not(.slick-cloned)').index($(this));
            if (clickedIndex < 0) return;
            openLightbox(clickedIndex);
        });
    }

    // -- Zavření lightboxu --
    $lightbox.find('.detail_lightbox__close').on('click', function () {
        $lightbox.fadeOut(200);
    });

    // Zavření klávesou Escape
    $(document).on('keydown.lightbox', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            if ($lightbox.is(':visible')) {
                $lightbox.fadeOut(200);
                $('body').removeClass('lightbox-open');
            }
        }
    });
};


if ($('.premium_description__image__slider').length) {
    $('.premium_description__image__slider').each(function () {
        $(this).slick({
            slidesToShow: 1,
            centerMode: false,
            arrows: false,
            dots: true
        });
    });
}

if ($('.premium_description__attr__show_more span').length) {
    $('.premium_description__attr__show_more span').click(function () {
        var $parentAttr = $(this).closest('.premium_description__attr');
        $parentAttr.addClass('show_all');
        var $parentAttr2 = $(this).closest('.premium_description').find('.premium_description__gallery');
        $parentAttr2.addClass('show_all');
        $(this).parent().hide();
    });
}